var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasSlot())?_vm._t("clickable",null,{"busy":_vm.isSharing,"share":_vm.share}):_c('p',[_vm._v("Share")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }